import React from 'react'
import { Alert } from 'components'
import { AlertContentStyles } from './Style'
import { useAlert } from 'components/Alerts/hooks'
import { useSelector } from 'react-redux'
import { alerts as alertKeys } from 'keys'
import { Img } from 'styles/GlobalStyle'
import ReactPlayer from 'react-player'

const PreviewAlert = () => {
    const { setAlerts } = useAlert()
    const { alerts } = useSelector(state => state.general)

    const handleAlert = (val) => {
        setAlerts(alertKeys.preview, val)
    }

    const isImg = alerts[alertKeys.preview].type == 'img'

    return (
        <Alert
            closeOnClick
            fullScreen
            systemUI
            handleAlert={handleAlert}>
            <AlertContentStyles>
                {isImg ?
                    <div className='img-preview'>
                        <Img src={alerts[alertKeys.preview].props} />
                    </div> :
                    <ReactPlayer
                        config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                        url={alerts[alertKeys.preview].props}
                        width='100%'
                        height='100%'
                        controls={true}
                        playing={true}
                    />
                }
            </AlertContentStyles>
        </Alert>
    )
}

export default PreviewAlert